import fetch from 'isomorphic-fetch';
import { /*API_URL,*/ API2_URL, PERMISSION_REQUEST, PERMISSIONS_EDIT, PERMISSIONS_SHOW, PERMISSIONS_LIST, PERMISSIONS_CLEAR, PERMISSIONS_DELETE, PERMISSION_FAIL } from './../store/config';
import { newNotification } from "./notifications";
import { history } from "../store/store";
import _ from "lodash";
import {sessionService} from "redux-react-session";

/* Permissions Show */
export const permissionsShow = (page = 1) =>{
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(permissionRequest());
				return fetch(`${API2_URL}/permissions?page=${page}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(permissionsData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(permissionFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

export const permissionsList = () => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(permissionRequest());
				return fetch(`${API2_URL}/permissions-groups`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(permissionsListData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(permissionFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

/* Permissions Edit */
export const permissionEdit = (id) =>{
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(permissionRequest());
				dispatch(permissionClear());
				return fetch(`${API2_URL}/permissions/${id}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(permissionEditData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(permissionFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

/* Permissions Save */
export const permissionSave = (values) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: JSON.stringify(values)
				};

				dispatch(permissionRequest());
				return fetch(`${API2_URL}/permissions${values.id ? `/${values.id}?_method=PUT`:''}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({title:"¡Éxito!", content: json.message, type: "success"}));
							if(_.isEmpty(values.id)){
								history.push(`/permisos/editar/${json.data.id}`);
							}
							return dispatch(permissionEditData(json));
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(permissionFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

/* Permissions Delete */
export const permissionDelete = (id) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'delete'
				};

				dispatch(permissionRequest());
				return fetch(`${API2_URL}/permissions/${id}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({title:"¡Éxito!", content: json.message, type: "success"}));
							dispatch(permissionsShow());
							return dispatch(permissionDeleteData(json));
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(permissionFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

const permissionRequest = () => {
	return {
		type: PERMISSION_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
};

const permissionsData = (json) => {
	return {
		type: PERMISSIONS_SHOW,
		isFetching: false,
		payload: json.data,
		pages: {
			current: json.current_page,
			per_page: json.per_page,
			total: json.total
		},
		permissions: json.permissions,
		timestamp: Date.now()
	};
};

const permissionsListData = (json) => {
	let p = {};
	_.mapValues(json.data, (item) => p[item.id] = item);
	return {
		type: PERMISSIONS_LIST,
		isFetching: false,
		payload: p,
		timestamp: Date.now()
	};
};

const permissionEditData = (json) => {
	return {
		type: PERMISSIONS_EDIT,
		isFetching: false,
		payload: json.data,
		permissions: json.permissions,
		timestamp: Date.now()
	}
};

const permissionClear = () => {
	return {
		type: PERMISSIONS_CLEAR,
		payload: {},
		permissions: [],
		timestamp: Date.now()
	}
}

const permissionDeleteData = (json) => {
	return {
		type: PERMISSIONS_DELETE,
		isFetching: false,
		payload: json,
		timestamp: Date.now()
	}
}

/*Fails*/
const permissionFail = (error) => {
	return {
		type: PERMISSION_FAIL,
		isFetching: false,
		data: {},
		error: error,
		timestamp: Date.now()
	}
};




// WEBPACK FOOTER //
// ./src/actions/permissions.js